<template>
    <v-container id="overlay">
        <v-layout>
            <v-flex md4 xs12 sm12 id="content">
                <div>
                    <v-flex xs12 class="title">Selecciona el tipus de rol a afegir</v-flex>
                    <v-flex xs12  class="item">
                        <v-select v-model="entity_type" :items="getEntitiesType" :label="getI18n('contact_relationship.new.type')"></v-select>
                    </v-flex>
                    <v-flex xs12  class="item">
                        <v-select v-show="entity_type" v-model="contact_type" :items="getContactsType" :label="getI18n('role')"></v-select>
                    </v-flex>
                    <v-flex xs12  class="item">
                        <div class="clear" v-if="!entity_type" style="height: 70px; position: relative; width: 100%"></div>
                    </v-flex>
                    <v-flex xs6  class="btn">
                        <v-btn @click="add" class="primary">{{ 'accept' | i18n }}</v-btn>
                    </v-flex>
                    <v-flex xs6  class="btn">
                        <v-btn @click="cancel">{{ 'cancel' | i18n }}</v-btn>
                    </v-flex>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import i18n from '@/i18n'
    import store from '@/store'

    export default {
        props: { },
        components: { },
        data() {
            return {
                entity_type: false,
                contact_type: false,
            }
        },
        computed: {
            getEntitiesType() {
                return [
                    { text: i18n.t( 'club' ), value: 1 },
                    { text: i18n.t( 'team' ), value: 2 },
                    { text: i18n.t( 'company' ), value: 5 },
                    { text: i18n.t( 'hotel' ), value: 3 },
                    { text: i18n.t( 'facility' ), value: 4 },

                ];
            },

            getContactsType() {
                var aContactTypes = store.getters[ 'persons/getContactTypes' ]( this.entity_type );
                var aReturn = [];
                var self = this;
                aContactTypes.forEach( type => {
                    if( type.type == self.entity_type ){
                        aReturn.push( { text: type.name, value: type.id } );
                    }
                });

                return aReturn;
            },
        },

        methods: {
            getLabel() {
                return 'test';
            },

            getI18n( label ){
                return i18n.t( label );
            },

            getEntity( ){
                var entity = false;
                switch( this.entity_type ){
                    case 1: entity = 'clubs';
                            break;
                    case 2: entity = 'teams';
                            break;
                    case 3: entity = 'hotels';
                            break;
                    case 4: entity = 'facilities';
                            break;
                    case 5: entity = 'companies';
                            break;
                }

                if( entity && typeof this.entities_loaded[ entity ] === 'undefined' ){
                    var self = this;
                    self.entities_loaded[ entity ] = 1;
                    store.dispatch( entity + '/loadList' ).then( function(){
                    });
                }
            },
            
            formatEventName( name, edition ){
                return name + "'" + edition.substring(2);
            },
            
            formatEventUrl( name, edition ){
                return '/event/' + ( name + edition.substring(2) ).toLowerCase();
            },

            getEvents() {
                var events = store.getters[ 'events/getActives' ]();
                var aEvents = [];
                var self = this;
                events.forEach( event => {
                    aEvents.push( { text: self.formatEventName( event.name, event.edition ), value: event.id } );
                })
                return aEvents;
            },

            add() {
                if( this.entity_type && this.contact_type ){
                    this.$emit( 'addRole', { entity: this.entity_type, contact_type: this.contact_type } )
                }
            },

            cancel() {
                this.$emit( 'cancelNewRole' )
            }
        },

        watch: {
        }
    }

</script>

<style lang="scss">
    #overlay {
        width: 100% !important;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0px;
        background-color: #0000005c !important;
        z-index: 40;
        max-width: unset;

        .layout {
            width: 100%;
            height: 100%;

            #content {
                margin: 0 auto;
                height: 225px;
                top: 50%;
                left: 0;
                transform: translate( 0, -112px );
                position: relative;
                border: 1px solid;
                border-radius: 5px;
                background: #FFF;
                z-index: 25;
                padding: 10px 20px;

                .v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active{
                    top: 35px !important;
                    left: 0 !important;
                    position: absolute !important;
                }

               
                .btn {
                    position: relative;
                    float: left;
                    display: contents;

                    button {
                        width: 50%;
                        display: inline-block;
                        margin: 0;

                        &.primary {
                            background-color: $main-color !important;
                            color: $bg-color;
                        }
                    }
                }
                
            }
        }
    }
</style>

